import React, {useContext} from 'react';
import {BrandContext} from "../../common/BrandContext";
import StudentTrailTabs from "./StudentTrailTabs";

const StudentTrails = () => {

    // const brandConfig = useContext(BrandContext);
        // testName = brandConfig.testName.toLowerCase();
        // selfCreateDiagnostics = brandConfig.selfCreateDiagnostics,
        // diagnosticNameLower = brandConfig.trailName.toLowerCase();

    // console.log('brandConfig: ',brandConfig);

    return (
            <StudentTrailTabs/>
    )

}
export default StudentTrails;
